import { t } from '@lingui/macro';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import {
    WirelessControllerFilter,
    TimeRangeFilter,
    useWirelessController,
    wirelessControllerFilterId,
} from '../../filters';
import { useSummarizedFilterStateById } from '../../../stores/FilterStateStore';
import { LAYOUT_WIDTH } from '../../page-framework/panel-container/PanelContainer';

import {
    WirelessControllerStatusBreakoutPanel,
    WirelessControllerCpuUtilizationPanel,
    WirelessControllerMemoryUtilizationPanel,
    WirelessControllerSyslogPanel,
    WirelessControllerPropertiesPanel,
} from '../../panels';

export const pageId = 'wireless-controller-detail';

export default function WirelessControllerDetailPage() {
    const wirelessController = useWirelessController();
    const [summarized] = useSummarizedFilterStateById(wirelessControllerFilterId);
    const title = summarized?.value;
    const [isAdminUser] = useIsAdminUser();

    return (
        <Page id={pageId}>
            <PageHeader
                title={title}
                titleActions={
                    wirelessController &&
                    !wirelessController.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link
                                to={`/admin/monitored-infrastructure/${wirelessController?.uuid}`}
                                title={t`Edit wireless controller configuration`}
                            >
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <WirelessControllerFilter required />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <WirelessControllerStatusBreakoutPanel width={LAYOUT_WIDTH.FULL} title={t`Status`} />
                <WirelessControllerCpuUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`CPU Utilization`} />
                <WirelessControllerMemoryUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Memory Utilization`} />
                <WirelessControllerSyslogPanel width={LAYOUT_WIDTH.FULL} title={t`Syslog Events`} />
                <WirelessControllerPropertiesPanel width={LAYOUT_WIDTH.FULL} title={t`Properties`} />
            </PanelContainer>
        </Page>
    );
}
